"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckList = exports.CheckListField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var A = __importStar(require("fp-ts/Array"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var index_1 = require("../../../index");
var Form_1 = require("../../Form");
var nameFieldsBuilder_1 = require("../../nameFieldsBuilder");
var fieldMaker_1 = require("../fieldMaker");
require("./checkList.css");
var CheckListField = /** @class */ (function (_super) {
    __extends(CheckListField, _super);
    function CheckListField(props) {
        var _this = _super.call(this, props) || this;
        _this.buildSentenceLabel = function (sentence) { return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: sentence.map(function (s) {
                switch (s.type) {
                    case 'text':
                        return (0, jsx_runtime_1.jsxs)("span", { children: [s.text, " "] }, "sentence-part-".concat(Math.random()));
                    case 'empathize':
                        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(index_1.FieldFormatter.Color, __assign({ color: "primary" }, { children: (0, jsx_runtime_1.jsx)(index_1.FieldFormatter.Empathize, { children: s.text }) })), ' '] }, "sentence-part-".concat(Math.random())));
                    case 'link':
                        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(index_1.FieldFormatter.Color, __assign({ color: "primary" }, { children: (0, jsx_runtime_1.jsx)(index_1.Hyperlink, { type: "link-real", borderless: true, href: s.link, label: s.text, target: "_blank" }) })), ' '] }, "sentence-part-".concat(Math.random())));
                }
            }) })); };
        _this.thereAreConditions = function (conditions) {
            return (0, function_1.pipe)(O.some(conditions), O.filter(A.isNonEmpty));
        };
        _this.buildPrincipalCondition = function (sentence, conditions) { return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [_this.buildSentenceLabel(sentence), (0, function_1.pipe)(_this.thereAreConditions(conditions), (0, Option_1.map)(function () { return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "principal-condition-action", onClick: function () { return _this.setState(function (prevState) { return ({ showConditions: !prevState.showConditions }); }); } }, { children: "Se vuoi selezionare i consensi singolarmente clicca qui" }))); }), O.toNullable)] })); };
        _this.onChangePrincipalCondition = function (conditions) { return function (value, flagged) {
            (0, function_1.pipe)(_this.thereAreConditions(conditions), O.map(function (c) {
                var slugs = flagged ? c.map(function (cc) { return cc.slug; }) : [];
                _this.setState({ conditionsSelected: slugs }, function () { return _this.props.onChange && _this.props.onChange(slugs, slugs); });
            }), O.getOrElse(function () {
                var slug = flagged ? ['onlyPrincipal'] : [];
                _this.setState({ conditionsSelected: slug }, function () { return _this.props.onChange && _this.props.onChange(slug, slug); });
            }));
        }; };
        _this.evaluatePrincipalConditionValue = function (conditions, conditionsSelected) {
            return (0, function_1.pipe)(_this.thereAreConditions(conditions), O.map(function (c) { return (conditionsSelected.length === c.length ? 1 : 0); }), O.getOrElse(function () { return (conditionsSelected.length > 0 ? 1 : 0); }));
        };
        _this.renderPrincipalCondition = function () { return ((0, jsx_runtime_1.jsx)(Form_1.Form.ChoiceOption, { name: (0, nameFieldsBuilder_1.buildFieldName)(_this.props.name, 'principal'), label: _this.buildPrincipalCondition(_this.props.principalSentence, _this.props.conditions), type: "checkbox", theme: "green-bordered", interactiveText: false, value: _this.evaluatePrincipalConditionValue(_this.props.conditions, _this.state.conditionsSelected), onChange: _this.onChangePrincipalCondition(_this.props.conditions), disabled: _this.props.disabled })); };
        _this.onChangeSentenceCondition = function (sentenceSlug) { return function (value, flagged) {
            var slugs = flagged
                ? __spreadArray(__spreadArray([], _this.state.conditionsSelected, true), [sentenceSlug], false) : __spreadArray([], _this.state.conditionsSelected.filter(function (s) { return s !== sentenceSlug; }), true);
            _this.setState({ conditionsSelected: slugs }, function () { return _this.props.onChange && _this.props.onChange(slugs, slugs); });
        }; };
        _this.renderConditions = function () {
            return _this.props.conditions.map(function (c) { return ((0, jsx_runtime_1.jsx)(index_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Form_1.Form.ChoiceOption, { name: c.slug, label: _this.buildSentenceLabel(c.sentence), type: "checkbox", interactiveText: false, value: _this.state.conditionsSelected.filter(function (s) { return s === c.slug; }).length > 0 ? 1 : 0, onChange: _this.onChangeSentenceCondition(c.slug) }) }), c.slug)); });
        };
        _this.state = {
            showConditions: !props.showConditionRecap,
            conditionsSelected: _this.props.value ? _this.props.value : [],
        };
        return _this;
    }
    CheckListField.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "check-list" }, { children: [this.props.showConditionRecap && this.renderPrincipalCondition(), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('check-list_sentenctes', { show: this.state.showConditions }) }, { children: (0, jsx_runtime_1.jsx)(index_1.FlexView, __assign({ gutters: { tb: 'std', lr: 'sm' }, hAlignContent: "between" }, { children: this.renderConditions() })) }))] })));
    };
    return CheckListField;
}(React.PureComponent));
exports.CheckListField = CheckListField;
CheckListField.defaultProps = {
    showConditionRecap: true,
};
exports.CheckList = (0, fieldMaker_1.makeField)(CheckListField);
//# sourceMappingURL=CheckList.js.map